/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const EditContactButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useContactUrl();

  return <EditButton path={id => getUpdateEntityUrl(id)} {...props} />;
};

export default EditContactButton;
